// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"29":"55956fa2d30e6546","146":"fea2ec488ddab8da","187":"f46f333233cad9a9","983":"4300f890e5e114d4"}[chunkId] + ".css";
};